import styled from 'styled-components'

export const RecurrenceSelectorOuter = styled.div`
  .o-recurrence-selector-row {
    background: ${p => p.theme.colors.$pureWhite} !important;
  }
`
RecurrenceSelectorOuter.displayName = 'RecurrenceSelectorOuter'
